import React, { useState } from "react";
import "../../PopUp/PopUP.css";
export default function ViewSummaryBtn({ event,setSummary1 }) {
  //const [summary, setSummary] = useState(false);
  return (
    <div>
      <div id="card_body_new">
        <button
          type="button"
          id="PopUpBtn"
          class="btn btn"
          onClick={() => {
            setSummary1(true);
          }}
        >
          View Summary
        </button>
      </div>
    </div>
  );
}
